module.exports = __webpack_public_path__ + "img/favicon.53e88170.png";